import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import TranslationUtils from 'Utils/TranslationUtils';
import { Helmet } from 'react-helmet';
import c from '../../../Components/AuthLayout/authContent.module.less';
import { AppSelectors } from '../../../Redux/modules/app/selectors';

function BlockPage({ blockReason = null }) {
  return (
    <>
      <Helmet>
        <title>{gettext('Vetting Not Allowed')}</title>
      </Helmet>
      <h1 test-id="page-title" className={c.title}>
        {TranslationUtils.getText('BLOCK_PAGE_TITLE')}
      </h1>
      {blockReason && (
        <p className={c.reason}>
          <span>Reason: </span>
          <span>{TranslationUtils.getText(blockReason)}</span>
        </p>
      )}
      <p className={c.text}>
        {TranslationUtils.getText('BLOCK_PAGE_SUBTITLE')}{' '}
        <a href="mailto:support@pipl.com">{TranslationUtils.getText('BLOCK_PAGE_LINK')}</a>
      </p>
    </>
  );
}

BlockPage.propTypes = {
  blockReason: PropTypes.string,
};

const withConnect = connect((state) => {
  return {
    blockReason: AppSelectors.onBoardingBlockReasonSelector(state),
  };
});

export default withConnect(BlockPage);
